import React from "react";

import { cn } from "~/components/ui/cn";

export type AlertProps = {
  /**
   * Define the appearance of the alert
   */
  appearance?: "default" | "success" | "warning" | "error";
} & React.ComponentProps<"div">;

export const Alert: React.FC<AlertProps> = ({
  appearance = "default",
  className,
  ...props
}: AlertProps) => {
  return (
    <div
      data-slot="alert"
      role="alert"
      className={cn(
        'group/alert grid rounded border p-6 has-[>div[data-slot=alert-action]]:relative has-[>svg]:grid-cols-[auto_1fr] has-[>svg]:gap-x-4 has-[>div[data-slot=alert-action]]:pr-18 [&>svg:not([class*="size-"])]:size-6 [&>svg]:row-span-2 [&>svg]:translate-y-0.5',
        {
          "border-gray-200 bg-gray-50 [&>svg]:text-gray-700":
            appearance === "default",
          "border-green-350 bg-green-300 [&>svg]:text-green-900":
            appearance === "success",
          "border-beige-400 bg-beige-300 [&>svg]:text-orange-600":
            appearance === "warning",
          "border-red-350 bg-red-300 [&>svg]:text-red-600":
            appearance === "error",
        },
        className,
      )}
      {...props}
    />
  );
};

Alert.displayName = "Alert";

export function AlertTitle({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="alert-title"
      className={cn(
        "mb-1 text-sm font-semibold text-gray-700 last:mb-0 group-has-[>svg]/alert:col-start-2",
        className,
      )}
      {...props}
    />
  );
}

export function AlertDescription({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="alert-description"
      className={cn("text-sm text-gray-700", className)}
      {...props}
    />
  );
}

export function AlertAction({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="alert-action"
      className={cn("absolute right-6 top-6", className)}
      {...props}
    />
  );
}
